module.exports = __webpack_public_path__ + "img/s1.a81b540c.jpg";